export enum AppLayoutsEnum {
  default = 'default',
  promo = 'promo',
  payment = 'payment',
  empty = 'empty',
  modern = 'modern'
}

export const AppLayoutToFileMap: Record<AppLayoutsEnum, string> = {
  default: 'Default.vue',
  promo: 'PromoLayouts.vue',
  payment: 'PaymentLayout.vue',
  empty: 'EmptyLayout.vue',
  modern: 'ModernLayout.vue'
}
